/**
 * Created by Alex A on 25/01/2016.
 */
/*
 General Landing Page JS
 */

(function() {

	if ( document.querySelectorAll('.general-landing-page').length === 0 ) {
    return;
  }

	var GLP_sliderIndex = 1,
		GLP_totalSlider = jQuery('.boxies [data-box]').length,
		GLP_runSlider = function(){
			if (GLP_sliderIndex < 1) {
				GLP_sliderIndex = GLP_totalSlider;
			}
			if (GLP_sliderIndex > GLP_totalSlider) {
				GLP_sliderIndex = 1;
			}
			var el = jQuery('.each-ex-content[data-box=' + GLP_sliderIndex + ']');
			jQuery(el)
				.addClass('active-box')
				.siblings('.active-box')
				.removeClass('active-box');
			el = jQuery('.boxies [data-box=' + GLP_sliderIndex + ']');
			jQuery(el)
				.addClass('active-box')
				.siblings('.active-box')
				.removeClass('active-box');

		};
	jQuery(document).on('click tap', 'section .boxies .each-ex-box', function(){
			if (!jQuery(this).hasClass('active-box')) {
				GLP_sliderIndex = jQuery(this).attr('data-box');
				GLP_runSlider();
			}
		})
		.on('click', 'section .pagination .go-left', function(){
			GLP_sliderIndex--;
			GLP_runSlider();
		})
		.on('click', 'section .pagination .go-right', function(){
			GLP_sliderIndex++;
			GLP_runSlider();
		})
		.on('swipe', '.ex-content > div', function(event){
			if ('ontouchstart' in window) {
				if (event.swipestart.coords[0] > event.swipestop.coords[0]) {
					GLP_sliderIndex--;
					GLP_runSlider();
				} else {
					GLP_sliderIndex++;
					GLP_runSlider();
				}
			}
		});

	jQuery(document).on('click tap', '.rfc-information a.btn.btn-primary.huge.url', function(e){
		if (jQuery(window).width() >= 768) {
			e.preventDefault();
			jQuery('html,body').stop().animate({
				scrollTop: jQuery('.rfc-title').parents('.row').position().top
			}, 1000);
		}
	});


	function rfcUrl(){
		if (jQuery(window).width() >= 768) {
			jQuery('a.btn-primary').each(function(){
				jQuery(this).attr( 'href','javascript:;' );
				jQuery(this).removeAttr( "target" );
				jQuery(this).addClass( 'open-pop-up' );
			});
		}else{
			jQuery('a.btn-primary').each(function(){
				jQuery(this).attr( 'href', jQuery(this).data('url') );
				jQuery(this).attr( 'target', '_blank' );
				jQuery(this).removeClass( 'open-pop-up' );
			});
		}
	}

	//simple slider functionality
	(function($){
		var index = 1,
			max = $('.simple-slider li').length,
			playSimpleSlider = function(){
				if (index < 1) {
					index = max;
				}
				if (index > max) {
					index = 1;
				}
				$('.simple-slider li.active').removeClass('active');
				$('.simple-slider li:nth-child(' + index + ')').addClass('active');
			};
		$(document).on('tap', '.template-b .slider-container .pagination .next', function(){
				index++;
				playSimpleSlider();
			})
			.on('tap', '.template-b .slider-container .pagination .prev', function(){
				index--;
				playSimpleSlider();
			})
			.on('swipe', '.simple-slider > ul', function(event){
				if ('ontouchstart' in window) {
					if (event.swipestart.coords[0] > event.swipestop.coords[0]) {
						index--;
						playSimpleSlider();
					} else {
						index++;
						playSimpleSlider();
					}
				}
			})
			.on('click', '.open-pop-up, [data-franchise]', function(){
				$('.pop-up-form-container').show();
				if($(this).attr('data-store')){
					$('.pop-up-form-container').attr('data-store',$(this).attr('data-store'));
				}
			})
			.on('click', '.close-pop-up', function(){
				$('.pop-up-form-container').hide();
				$('.pop-up-form-container').removeAttr('data-store');
			})
			.ready(function(){
				if (max == 1) {
					$('.template-b .slider-container .pagination').remove();
				}
			});
		if (typeof coordinateA != "undefined" && coordinateA.length > 1) {
			var map,
				markers = [],
				infowindow = null;
			map = new google.maps.Map(document.getElementById('showrooms-map'), {
				zoom: 5,
				disableDefaultUI: true,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				center: {
					lat: coordinateA[0].coords[0],
					lng: coordinateA[0].coords[1]
				}
			});
			var bounds = new google.maps.LatLngBounds();
			for (var j = 0; j < coordinateA.length; j++) {
				markers[j] = new google.maps.Marker({
					position: new google.maps.LatLng(coordinateA[j].coords[0], coordinateA[j].coords[1]),
					map: map,
					title: coordinateA[j].title,
					markerContent: '<h4>' + coordinateA[j].title + '</h4>' + coordinateA[j].address,
					markerID: j,
					icon: coordinateA[j].icon
				});
				//extend the bounds to include each marker's position
				bounds.extend(markers[j].position);
				google.maps.event.addListener(markers[j], 'click', function(){
					var infoContent = this.markerContent;
					if (infowindow) {
						infowindow.close();
					}
					infowindow = new google.maps.InfoWindow({
						content: infoContent,
						markerID: this.markerID
					});
					infowindow.open(map, this);
					_st.render();
					_st.triggerPageHit();

				});
			}
			map.fitBounds(bounds);
		}

		function createGallery(){
			var jcarousel = $('.gallery-wrapper .jcarousel'),
				width = jcarousel.innerWidth(),
				itemPerPage = 4;
			if (width < 750) {
				itemPerPage = 2;
			}
			jcarousel
				.on('jcarousel:reload jcarousel:create', function(){
					width = jcarousel.innerWidth();
					if (width >= 750) {
						width = width / 4;
					} else {
						width = width / 2;
					}
					jcarousel.jcarousel('items').css('width', width + 'px');
				})
				.jcarousel({
					wrap: 'circular'
				});
			$('.gallery-pagination>div.prev').jcarouselControl({
				target: '-=1'
			});

			$('.gallery-pagination>div.next').jcarouselControl({
				target: '+=1'
			});
			$('.testimonial-block .jcarousel-pagination')
				.on('jcarouselpagination:active', 'a', function(){
					$(this).addClass('active');
				})
				.on('jcarouselpagination:inactive', 'a', function(){
					$(this).removeClass('active');
				})
				.on('click', function(e){
					e.preventDefault();
				}).jcarouselPagination({
				perPage: itemPerPage,
				item: function(page){
					return '<a href="#' + page + '">' + page + '</a>';
				}
			});
			jcarousel.swipe({
				//Generic swipe handler for all directions
				swipeLeft: function(event, direction, distance, duration, fingerCount, fingerData){
					jcarousel.jcarousel('scroll', '+=1');
				},
				swipeRight: function(event, direction, distance, duration, fingerCount, fingerData){
					jcarousel.jcarousel('scroll', '-=1');
				},
			});
		}

		$(document).ready(function(){
			createGallery();
		});
		$(window).resize(function(){
			createGallery();
		});
		if ($('[data-phone-dynamic]').length > 0) {
			$.ajax({
				url: ajaxurl,
				type: "POST",
				data: {action: "return_landing_settings_ajax_async",country:$('[name="country"]').val()},
				success: function(response){
					var result = JSON.parse(response);
					if (result.status == true) {
						$('[data-phone-dynamic]').each(function(){
							if ($(this).attr('href')) {
								$(this).attr('href', 'tel:' + result.settings.phone);
							}
							if ($(this).parent('a').attr('href') && $(this).parent('a').attr('href').indexOf('tel:') > -1) {
								$(this).parent('a').attr('href', 'tel:' + result.settings.phone);
							}
							if (!this.hasAttribute('data-no-html')) {
								$(this).html(result.settings.phone);
							}
						});
					}
					$('[data-phone-dynamic]').css('opacity', 1);
				}
			})
		}
	})(jQuery);


	jQuery(document).ready(function ($){
		rfcUrl();
	});

	jQuery(window).resize(function (){
		rfcUrl();
	});
})();
